import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { Button, List, Typography } from 'antd';
import MeasureUtils from 'app/common/util/MeasureUtils';
import TimePeriodUtils from 'app/common/util/TimePeriodUtils';
import { ATFCMDetail } from 'app/model/SOL49';
import ConditionalRender from 'app/common/components/ConditionalRender';
import Utils from 'app/common/util/Utils';
import { CloseCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';
import { HotspotDto } from 'app/model/CORE';

export class ATFCMDetailsPanel extends PureComponent<{
    details: { [fmp: string]: ATFCMDetail };
    onChange: (details: { [fmp: string]: ATFCMDetail }) => void;
}> {
    private updateInfo = (tvSet: string, info: string) => {
        const copy = Object.assign({}, this.props.details);
        copy[tvSet].info = info;
        this.props.onChange(copy);
    };

    private deleteInfo = (tvSet: string) => {
        const { info, ...rest } = this.props.details[tvSet];
        const copy = Object.assign({}, this.props.details);
        copy[tvSet] = rest;
        this.props.onChange(copy);
    };

    render() {
        return Object.entries(this.props.details).map(([tvSet, { info, regulations, scenarios, hotspots }]) => {
            return (
                <Flex direction="vertical" className="atfcm-details" key={tvSet}>
                    <Flex direction="horizontal" style={{ alignItems: 'center' }}>
                        <p className="fmp">{tvSet}</p>
                        <ConditionalRender condition={Utils.isNotExists(info)}>
                            <Button
                                style={{ marginLeft: '2em', marginBottom: '1em' }}
                                size="small"
                                onClick={() => this.updateInfo(tvSet, '')}>
                                Add info
                                <PlusCircleOutlined />
                            </Button>
                        </ConditionalRender>
                    </Flex>
                    <ConditionalRender condition={Utils.isExists(info)}>
                        <Flex direction={'horizontal'}>
                            <TextArea
                                style={{ marginBottom: '0.5em' }}
                                value={info}
                                onChange={event => this.updateInfo(tvSet, event.target.value)}
                            />
                            <CloseCircleOutlined
                                style={{ marginLeft: '1em', marginBottom: '0.5em', alignSelf: 'center' }}
                                onClick={() => this.deleteInfo(tvSet)}
                            />
                        </Flex>
                    </ConditionalRender>
                    {regulations.length > 0 && (
                        <List
                            header={<p className="header">Regulations</p>}
                            size={'small'}
                            bordered
                            dataSource={regulations}
                            renderItem={regulation => (
                                <List.Item key={regulation.measureId.id}>
                                    <Typography.Text style={{ width: '70em' }}>
                                        {MeasureUtils.getTvLocation(regulation).id}{' '}
                                        {TimePeriodUtils.formatHHMM(regulation.applicability)} : {regulation.reason}{' '}
                                        {regulation.remark ? `- ${regulation.remark}` : ''}
                                    </Typography.Text>
                                </List.Item>
                            )}
                        />
                    )}
                    {scenarios.length > 0 && (
                        <List
                            header={<p className="header">Scenarios</p>}
                            size={'small'}
                            bordered
                            dataSource={scenarios}
                            renderItem={scenario => (
                                <List.Item
                                    key={scenario.scenarioReference.scenarioId}
                                    style={{ lineHeight: '1.5em', whiteSpace: 'pre-line' }}>
                                    <Typography.Text style={{ width: '70em' }}>
                                        {MeasureUtils.getTvLocation(scenario).id}{' '}
                                        {TimePeriodUtils.formatHHMM(scenario.applicability)} :{' '}
                                        {scenario.location.description}
                                    </Typography.Text>
                                </List.Item>
                            )}
                        />
                    )}
                    {hotspots.length > 0 && (
                        <List
                            header={<p className="header">Hotspots</p>}
                            size={'small'}
                            bordered
                            dataSource={hotspots}
                            renderItem={(hotspot: HotspotDto, index: number) => (
                                <List.Item
                                    key={`${hotspot.hotspotId.tvId}-${index}`}
                                    style={{ lineHeight: '1.5em', whiteSpace: 'pre-line' }}>
                                    <Typography.Text style={{ width: '70em' }}>
                                        {hotspot.hotspotId.tvId}{' '}
                                        {TimePeriodUtils.formatHHMM(hotspot.hotspotId.timePeriod)} : {hotspot.remark}
                                    </Typography.Text>
                                </List.Item>
                            )}
                        />
                    )}
                </Flex>
            );
        });
    }
}
